<template>
    <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        :style="{ backgroundColor }"
        xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12.8239 42.7065C11.7076 42.7065 10.7636 42.3235 9.99206 41.5575C9.22049 40.7915 8.83471 39.8542 8.83471 38.7456V10.7261H6.30426V6.76519H16.9196V4.75644H31.0522V6.76519H41.6958V10.7261H39.1653V38.7456C39.1653 39.8292 38.7733 40.7602 37.9892 41.5387C37.2051 42.3173 36.2674 42.7065 35.1761 42.7065H12.8239ZM35.1761 10.7261H12.8239V38.7456H35.1761V10.7261ZM17.9826 34.6717H21.4631V14.7217H17.9826V34.6717ZM26.537 34.6717H30.0457V14.7217H26.537V34.6717Z"
            fill="currentColor" />
    </svg>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        props: {
            backgroundColor: {
                type: String,
                required: true,
            },
        },
    });
</script>
